import type { ProjectFixture } from "./fixtures";

/** Laterite Collective's small portfolio (Kerala), so switching organisation visibly changes the Projects page. */

const DAY_MINS = 1_440;

export const LATERITE_FIXTURES: readonly ProjectFixture[] = [
  {
    id: "fort-kochi-library",
    name: "Fort Kochi Library Reuse",
    client: "Kochi Heritage Trust",
    type: "H3",
    city: "Kochi",
    state: "Kerala",
    address: "Bastion Street, Fort Kochi",
    plotAreaM2: 1_450,
    stageIndex: 1,
    health: { state: "on_track" },
    next: { title: "Condition survey review", inDays: 4 },
    team: ["p-joseph", "p-farah", "p-asha"],
    updatedMinsAgo: 50,
    pinned: true,
    attention: 1,
    modules: {
      site: ["Survey", "neutral"],
      design: ["Ready", "pass"],
      studio: ["3 open", "neutral"],
    },
  },
  {
    id: "alleppey-lake-house",
    name: "Alleppey Lake House",
    client: "Varghese family",
    type: "A1",
    city: "Alappuzha",
    state: "Kerala",
    plotAreaM2: 2_100,
    stageIndex: 2,
    health: { state: "at_risk", reason: "Client review is 4 days late" },
    next: { title: "Plan options to the client", inDays: 2 },
    team: ["p-farah", "p-joseph"],
    updatedMinsAgo: 6 * 60,
    attention: 2,
    modules: {
      site: ["Ready", "pass"],
      design: ["1 issue", "warn"],
      render: ["2", "neutral"],
      studio: ["4 open", "neutral"],
    },
  },
  {
    id: "kumarakom-retreat-landscape",
    name: "Kumarakom Retreat Landscape",
    client: "Backwater Hospitality",
    type: "L6",
    city: "Kumarakom",
    state: "Kerala",
    plotAreaM2: 26_000,
    stageIndex: 1,
    health: { state: "on_track" },
    next: { title: "Planting palette workshop", inDays: 9 },
    team: ["p-farah", "p-asha"],
    updatedMinsAgo: 3 * DAY_MINS,
    attention: 0,
    modules: {
      site: ["Ready", "pass"],
      design: ["Not started", "neutral"],
      studio: ["2 open", "neutral"],
    },
  },
];
